import Primary from "./Primary";
import Mobile from "./Mobile";
import Static from "./Static";

export default {
  Primary,
  Mobile,
  Static
};
